import React,  { useState, useRef, useEffect } from  "react";

import PropTypes from 'prop-types';

import TimerOutlined from  "@material-ui/icons/TimerOutlined";
import LocalShippingOutlined from  "@material-ui/icons/LocalShippingOutlined";
import PhoneAndroidOutlined from "@material-ui/icons/PhoneAndroidOutlined";

import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import DeleteIcon  from '@material-ui/icons/Delete';

import { IMaskInput } from 'react-imask';

import useStyles from './styles';

import { formatPhone } from '../../../utils/phone';
import ConfirmDialog from "../ConfirmDialog";

import sim1Icon from "../../../assets/images/sim1.svg";
import sim2Icon from "../../../assets/images/sim2.svg";

const Info = ({data, handleRefreshChat, handleUpdatePhone1, handleUpdatePhone2, onEditMode1, onEditMode2 }) => {
    const [popup, setPopup] = useState({show: false});

    const ref1 = useRef(null);
    const ref2 = useRef(null);

    const [isEditMode1, setEditMode1] = useState(false);
    const [isEditMode2, setEditMode2] = useState(false);
    const [enableSave1, setEnableSave1] = useState(false);
    const [enableSave2, setEnableSave2] = useState(false);
    const [phone1, setPhone1] = useState(data?.driver?.phone1);
    const [phone2, setPhone2] = useState(data?.driver?.phone2);

    const classes = useStyles();

    useEffect(() => {
      setPhone1(data?.driver?.phone1);
    }, [data.driver.phone1, setPhone1])

    useEffect(() => {
      setPhone2(data?.driver?.phone2);
    }, [data.driver.phone2, setPhone2])

    useEffect(() => {
      setEditMode1(onEditMode1);
    }, [onEditMode1, setEditMode2])

    useEffect(() => {
      setEditMode2(onEditMode2);
    }, [onEditMode2, setEditMode2])

    const handleEdit1 = () => {
        setEditMode1(true);
    }

    const handleEdit2 = () => {
      setEditMode2(true);
    }

    const closePopup = () => {
        setPopup({...{show:false}, popup})
    }

    const handleOnBlurPhone1 = () => {
        if(phone1.length < 11) {
            setEditMode1(false);
            setPhone1(data?.driver?.phone1)
        }else{
            handleSavePhone1();
        }
    }

    const handleSavePhone1 = () => {
        setEditMode1(false);

        if(data?.driver?.phone2 === phone1){
            setPhone1(data?.driver?.phone1);
        }else{
            setPopup({
                show:true,
                type: 'warning',
                message: `Deseja realmente atualizar o telefone para ${formatPhone(phone1)}</strong>?`,
                handlerRefuse: () => {
                    closePopup();
                    setPhone1(data?.driver?.phone1);
                },
                handlerAccept: () => {
                    handleUpdatePhone1(phone1);
                    closePopup()
                }
            })
        }
    }

    const handleOnBlurPhone2 = () => {
      if(phone2.length < 11) {
          setEditMode2(false);
          setPhone2(data?.driver?.phone2)
      }else{
          handleSavePhone2();
      }
  }

  const handleSavePhone2 = () => {
      setEditMode2(false);

      if(data?.driver?.phone1 === phone2){
        setPhone2(data?.driver?.phone2);
      }else{
        setPopup({
            show:true,
            type: 'warning',
            message: `Deseja realmente atualizar o telefone para ${formatPhone(phone2)}</strong>?`,
            handlerRefuse: () => {
                closePopup();
                setPhone2(data?.driver?.phone2);
            },
            handlerAccept: () => {
                handleUpdatePhone2(phone2);
                closePopup()
            }
        })
     }
  }

  const handleRemovePhone2 = () => {

        setPopup({
            show:true,
            type: 'warning',
            message: `Deseja realmente excluir o telefone 2?`,
            handlerRefuse: () => {
                closePopup();
            },
            handlerAccept: () => {
                if(!!data?.driver?.phone2){
                    handleUpdatePhone2(null);
                }
                closePopup()
            }
        })
   }

    return (
      <div className={classes.info} id={`classes-info`} data-cy={`classes-info`}>
        <div className={`${classes.infoItem} ${classes.itemRow}`} id={`classes-item-row`} data-cy={`classes-item-row`}>
          <div className={classes.timerWrapper} id={`classes-timer-wrapper`} data-cy={`classes-timer-wrapper`}>
              <TimerOutlined className={`${classes.clockIcon} ${classes.colorIcon}`} id={`classes-big-icon`} data-cy={`classes-big-icon`}/>
          </div>
          <div className="code-text" id={`classes-code-text`} data-cy={`classes-code-text`}>
              <div className={classes.textGray30} id={`classes-text-agendamento`} data-cy={`classes-text-agendamento`}>
                  Agendamento
              </div>
              <div className={classes.infoValue} id={`classes-info-value`} data-cy={`classes-info-value`}>
                  {data?.id}
              </div>
          </div>
        </div>
        <div className={classes.infoBorder} id={`opaque-line-id`} data-cy={`opaque-line-data-cy`}></div>
        <div className={`${classes.infoItem} ${classes.infoLeftSpace}`} id={`classes-info-plate`} data-cy={`classes-info-plate`}>
            <div className={`${classes.infoItem} ${classes.itemRow} ${classes.infoDriverLeft}`} id={`classes-item-row-driver`} data-cy={`classes-item-row-driver`}>
                <div className={classes.smallIcon} id={`classes-small-icon`} data-cy={`classes-small-icon`}>
                    <LocalShippingOutlined  className={classes.colorIcon} id={`local-shipping-outlined`} data-cy={`local-shipping-outlined`}/>
                </div>
                <div className={classes.infoDriverLabel} id={`info-driver-label`} data-cy={`info-driver-label`}>
                    Placa
                </div>
                <div className={classes.infoValue} id={`info-driver-plate`} data-cy={`info-driver-plate`}>
                    {data?.driver?.plate}
                </div>
            </div>
            <div className={`${classes.infoItem} ${classes.itemRow} ${classes.infoDriverLeft}`} id={`item-row-phone-1`} data-cy={`item-row-phone-1`}>
              <div className={classes.phoneElement}>
                <div className={classes.smallIcon} id={`item-row-phone-1-small-icon`} data-cy={`item-row-phone-1-small-icon`}>
                    <PhoneAndroidOutlined className={classes.colorIcon} id={`item-row-phone-1-color-icon`} data-cy={`item-row-phone-1-color-icon`}/>
                </div>
                <div className={classes.infoDriverLabel} id={`item-row-phone-1-info-driver-level`} data-cy={`item-row-phone-1-info-driver-level`}>
                    {`Telefone ${true && ` (s)`}`}
                </div>
              </div>
              <div className={classes.allPhones} id={`all-phones-container-id`} data-cy={`all-phones-container-data-cy`}>
                <div className={classes.phoneElement} id={`phone-element-row1`} data-cy={`phone-element-row1`}>
                  <img alt={`sim1`} src={sim1Icon} id={`sim-element1-img`} data-cy={`sim-element1-img`}/>
                  <div className={classes.infoValue} id={`item-row-phone-1-mask-div`} data-cy={`item-row-phone-1-mask-div`}>
                      {
                          !isEditMode1 && formatPhone(phone1)
                      }
                      {
                          isEditMode1 &&
                          (
                              <IMaskInput
                                  className={classes.inputPhone}
                                  mask="00 00000 0000"
                                  value={phone1}
                                  unmask={true}
                                  ref={e => {
                                      if(e?.maskRef != null){
                                          ref1.current = e?.maskRef?.el?.input
                                          ref1.current.focus()
                                      }
                                  }}
                                  onAccept={
                                      (value, mask) =>{
                                          setEnableSave1(value?.length > 10)
                                          setPhone1(value)
                                      }
                                  }
                                  onBlur={handleOnBlurPhone1}
                                  placeholder=''
                                  id={`phone-1-imask-input`}
                                  data-cy={`phone-1-imask-input`}
                              />
                          )
                      }
                  </div>
                  <div className={classes.smallIcon} id={`edit-icon-div`} data-cy={`edit-icon-div`}>
                      {
                          !isEditMode1 &&
                          (
                              <button className={classes.noButtonStyle} onClick={handleEdit1} id={`edit-icon-button`} data-cy={`edit-icon-button`}>
                                  <EditIcon className={classes.colorIcon} id={`edit-icon-editicon`} data-cy={`edit-icon-editicon`}/>
                              </button>
                          )
                      }

                      {
                          isEditMode1 &&

                          <button disabled={!enableSave1} className={classes.noButtonStyle} onClick={handleSavePhone1} id={`save-icon-button`} data-cy={`save-icon-button`}>
                              <SaveIcon className={enableSave1 ? classes.colorIcon : classes.disabledIcon} style={{marginTop: '3px'}} id={`save-icon-saveicon`} data-cy={`save-icon-saveicon`}/>
                          </button>
                      }
                  </div>
                </div>
                <div className={classes.phoneElement} id={`phone-element-row2`} data-cy={`phone-element-row2`}>
                  <img alt={`sim2`} src={sim2Icon} id={`sim-element2-img`} data-cy={`sim-element2-img`}/>
                  <div className={classes.infoValue} id={`item-row-phone-2-formatphone`} data-cy={`item-row-phone-2-formatphone`}>
                      {
                          !isEditMode2 && formatPhone(phone2)
                      }
                      {
                          isEditMode2 &&
                          (
                              <IMaskInput
                                  className={classes.inputPhone}
                                  mask="00 00000 0000"
                                  value={phone2}
                                  unmask={true}
                                  ref={e => {
                                      if(e?.maskRef != null){
                                          ref2.current = e?.maskRef?.el?.input
                                          ref2.current.focus()
                                      }
                                  }}
                                  onAccept={
                                      (value, mask) =>{
                                          setEnableSave2(value?.length > 10)
                                          setPhone2(value)
                                      }
                                  }
                                  onBlur={handleOnBlurPhone2}
                                  placeholder=''
                                  id={`phone-2-imask-input`}
                                  data-cy={`phone-2-imask-input`}
                              />
                          )
                      }
                  </div>
                  <div className={classes.smallIcon} id={`item-row-phone-2-editdiv`} data-cy={`item-row-phone-2-editdiv`}>
                      {
                          !isEditMode2 &&
                          (
                              <div className={classes.containerButtonStyle}>
                                <button className={classes.noButtonStyle} onClick={handleEdit2} id={`item-row-phone-2-edit-button`} data-cy={`item-row-phone-2-edit-button`}>
                                    <EditIcon className={classes.colorIcon} id={`item-row-phone-2-edit-icon`} data-cy={`item-row-phone-2-edit-icon`}/>
                                </button>
                                <button className={classes.noButtonStyle} onClick={handleRemovePhone2} id={`item-row-phone-2-remove-button`} data-cy={`item-row-phone-2-remove-button`}>
                                   {
                                    !!phone2 && (
                                        <DeleteIcon  className={classes.colorDangerIcon} id={`item-row-phone-2-remove-icon`} data-cy={`item-row-phone-2-remove-icon`}/>
                                    )

                                   }
                                </button>
                               </div>
                          )
                      }

                      {
                          isEditMode2 &&

                          <button disabled={!enableSave2} className={classes.noButtonStyle} onClick={handleSavePhone2} id={`item-row-phone-2-save-button`} data-cy={`item-row-phone-2-save-button`}>
                              <SaveIcon className={enableSave2 ? classes.colorIcon : classes.disabledIcon} style={{marginTop: '3px'}} id={`item-row-phone-2-save-icon`} data-cy={`item-row-phone-2-save-icon`}/>
                          </button>
                      }
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div className={`${classes.infoItem} ${classes.itemRow} ${classes.alignRight}`} id={`div-updated`} data-cy={`div-updated`}>

        </div>
        <ConfirmDialog
          isOpen={popup?.show}
          type={popup?.type}
          message={popup?.message}
          handlerRefuse={popup?.handlerRefuse}
          handlerAccept={popup?.handlerAccept}
          id={`info-confirm-dialog`}
          data-cy={`info-confirm-dialog`}
        />
      </div>
    );
}

Info.propTypes = {
    data: PropTypes.object.isRequired,
    handleRefreshChat: PropTypes.func.isRequired,
    handleUpdatePhone1: PropTypes.func.isRequired,
    handleUpdatePhone2: PropTypes.func.isRequired
};

export default Info;
